module.exports = __webpack_public_path__ + "assets/img/m_bg.faf8c034.png";